// extracted by mini-css-extract-plugin
export default {"detailContainer":"P2EDetailPage_detailContainer__dgW0-","detailImage":"P2EDetailPage_detailImage__pWYph","detailDescription":"P2EDetailPage_detailDescription__nqyDS"};